import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StyleMerchLocationGroup } from 'src/graphql/generated/graphql';
import { RootState } from '@store/store';

export type UserInformationState = {
  alias: string | null;
  allowedStyleMerchLocationGroup: StyleMerchLocationGroup[] | null | undefined;
};

const initialState: UserInformationState = {
  alias: null,
  allowedStyleMerchLocationGroup: null,
};

export type UpdateUserInfoPayload = {
  alias: string;
  allowedStyleMerchLocationGroup: StyleMerchLocationGroup[] | null | undefined;
};

export const userInformationSlice = createSlice({
  name: 'userInformation',
  initialState,
  reducers: {
    updateUserInformation: (state, action: PayloadAction<UpdateUserInfoPayload>) => {
      const {
        payload: { alias, allowedStyleMerchLocationGroup },
      } = action;
      state.alias = alias;
      state.allowedStyleMerchLocationGroup = allowedStyleMerchLocationGroup;
    },
  },
});

export const { updateUserInformation } = userInformationSlice.actions;
export const selectAllowedMerchLocationGroups = (state: RootState) =>
  state.userInformation.allowedStyleMerchLocationGroup;

export default userInformationSlice.reducer;
